import { styled } from "styled-components";

export const MobileMemberHistoryWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background: #fff;
  width: calc(100% - 32px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 13px;
  padding: 20px 10px;
  box-sizing: border-box;
`;

export const MobileMemberHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  > .back {
    cursor: pointer;
    width: 14px;
    height: 14px;

    > .img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const MobileMemberHistoryInfoHeader = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 6.5px;

  > div {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 600;
  }
`;

export const MobileMemberHistoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 180px;
  margin-bottom: 15px;
`;

export const MobileMemberHistoryListItem = styled.div`
  background: #ecf0f3;
  height: 30px;
  padding: 0px 10px;
  border-radius: 11.47px;
  display: flex;
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  align-items: center;

  > .a {
    width: 40%;
  }
  > .b {
    width: 30%;
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;

    .more {
      position: relative;
      width: 14px;
      height: 14px;
      cursor: pointer;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > .item {
    width: 20%;

    > span {
      padding: 4px 9px;
      border-radius: 100px;
      background: #f00;
      color: #fff;
      cursor: pointer;
    }
  }
`;
